import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { CalendarEventResponseCoreFragment } from 'generated/graphql';

export interface ListEventsDialogData {
  day: any;
  entityId?: string;
}

@Component({
  selector: 'app-list-events-dialog',
  templateUrl: `./list-events.dialog.html`,
})
export class ListEventsDialog implements OnInit {
  day;
  entityId;

  onEventResponseUpdate = new EventEmitter<CalendarEventResponseCoreFragment>();

  static open(dialog: MatDialog, config: MatDialogConfig<ListEventsDialogData>) {
    return dialog.open(ListEventsDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<ListEventsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ListEventsDialogData,
    private _router: Router
  ) {
    // Close dialog
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Close the dialog when a route change is detected
        dialogRef.close();
      }
    });
  }

  onListEventResponseUpdate(response: CalendarEventResponseCoreFragment) {
    // Update local data
    this.day = {
      ...this.day,
      events: this.day.events.map((event) => {
        if (event.id === response.calendarEvent.id) {
          return { ...event, status: response.status };
        }
        return event;
      })
    };
    this.onEventResponseUpdate.emit(response);
  }

  ngOnInit(): void {
    this.day = this.data.day;
    this.entityId = this.data.entityId;
  }

  // Close dialog and pass along event data.
  close(event = null) {
    this.dialogRef.close(event);
  }
}
